import script from "./applayForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./applayForm.vue?vue&type=script&lang=ts&setup=true"

import "./applayForm.vue?vue&type=style&index=0&id=38636ea0&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38636ea0"]])

export default __exports__